import {Nullish} from 'shared/web';

import {DEFAULT_ALLOWED_TAGS} from '../constants/defaultAllowedTags';
import {RichTextProps} from '../types';
import {ensureHTML} from './ensureHTML';
import {sanitizeHTML} from './sanitizeHTML';

export function normalizeValue(
  value: string | Nullish,
  allowedTags: RichTextProps['allowedTags']
): string {
  return sanitizeHTML(ensureHTML(value), allowedTags ?? [...DEFAULT_ALLOWED_TAGS]);
}
